<!--
 * @Author: Wot
 * @Date: 2022-04-21 14:59:36
 * @LastEditors: zxf
 * @LastEditTime: 2023-05-04 18:31:15
 * @Description: file content
-->
<template>
  <div>
    <!-- gnmk 专属角色直接渲染新首页，替代原有首页内容 -->
    <gnmk-home v-if="isGnmkUser" />
    <jxxf-home v-else-if="isJxxfUser" />

    <div
      v-else
      class="l-page l-page--main"
    >
      <div class="dev-c-app__header">
        <div
          v-for="item in vacationData"
          :key="item.imgName"
          class="dev-o-app"
          :class="'dev-o-app--'+ item.imgName"
        >
          <div
            class="dev-o-app__img"
          >
            <img
              class="dev-o-app__img-inner"
              :src="item.imgSrc"
            >
          </div>
          <div class="dev-o-app__info">
            <div
              class="dev-o-app__count"
              @click="goToEntry(item.path)"
            >
              {{ vacationParams[item.imgName] }}
            </div>
            <div class="dev-o-app__text">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
      <!-- 页面主内容 Start -->
      <div
        class="dev-c-app__content"
      >
        <!-- 导航类查询条件 Start -->
        <div class="dev-c-app__panel dev-c-app__panel--left">
          <div class="dev-c-app__panel-header">
            <div class="dev-c-app__panel-title">
              快捷入口
            </div>
          </div>
          <div
            class="dev-c-app__panel-body"
          >
            <div
              class="dev-o-enter"
            >
              <div
                v-for="(item,index) in manageEntrance"
                :key="index"
                class="dev-o-enter__item"
                @click="goToEntry(item.path)"
              >
                <div
                  class="dev-o-enter__icon"
                  :class="'o-'+item.code"
                >
                  <img
                    class="dev-o-enter__img"
                    :src="item.imgSrc"
                  >
                </div>
                <div class="dev-o-enter__text">
                  {{ item.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 快捷入口 End -->

        <!-- 待办面板 Start -->
        <div
          class="dev-c-app__panel dev-c-app__panel--right"
        >
          <div class="dev-c-app__panel">
            <div class="dev-c-app__panel-header">
              <div class="dev-c-app__panel-title">
                维保任务进度监测
              </div>
            </div>
            <div
              class="dev-c-app__panel-body"
              style="margin-top: 12px;"
            >
              <div
                v-if="processList.length > 0"
                class="dec-c-app__table-body"
              >
                <el-table
                  :data="processList"
                  style="width: 100%;"
                  :header-cell-style="{padding: '15px 0'}"
                  :cell-style="{padding: '12px 0'}"
                  :row-class-name="tableRowClassName"
                >
                  <el-table-column
                    prop="lbmc"
                    label="类别"
                    min-width="180"
                  />
                  <el-table-column
                    prop="xmsl"
                    align="center"
                    label="客户数量"
                    width="80"
                  />
                  <el-table-column
                    prop="jhsl"
                    align="center"
                    label="维保计划"
                    width="80"
                  />
                  <el-table-column
                    prop="wzdsl"
                    align="center"
                    width="80"
                    label="未制定计划"
                  />
                  <el-table-column
                    prop="jhzdlStr"
                    label="计划制定率"
                    align="center"
                    width="80"
                  />
                  <el-table-column
                    prop="wcsl"
                    label="维保完成数量"
                    align="center"
                    width="80"
                  />
                  <el-table-column
                    prop="wwcsl"
                    label="未完成数量"
                    align="center"
                    width="80"
                  />
                  <el-table-column
                    prop="wbwclStr"
                    label="维保完成率"
                    align="center"
                    width="80"
                  />
                </el-table>
              <!-- <div
                v-for="item in bgList"
                :key="item.xmId"
                class="dev-o-todo__item"
                @click="handleBgDetail(item)"
              >
                <div>
                  <div class="dev-o-todo__icon" />
                </div>

                <div class="dev-o-todo__date">
                  【{{ item.bglx }}】
                </div>
                <div
                  class="dev-o-todo__title"
                  :title="item.bgmc+'（'+item.xmmc+'）'"
                >
                  <template
                    v-if="item.bglx==='消防维保'"
                  >
                    {{ item.bgmc }}（{{ item.xmmc }}）
                  </template>
                  <template
                    v-else
                  >
                    {{ item.bgmc }}
                  </template>
                </div>

                <div class="dev-o-todo__arrow">
                  <i class="kestrel-icon ki-right" />
                </div>
              </div> -->
              </div>
              <div
                v-else-if="!todoDataLoading"
                class="dev-c-app__panel-empty"
              >
                <img
                  src="~images/main/daiban.png"
                >
                <span>暂无报告数据！</span>
              </div>
            </div>
          </div>
        </div>
      <!-- 查询结果 End -->
      </div>

    <!-- 页面主内容 End -->
    </div>
  </div>
</template>

<script>

import { mainService } from './main.service';
import GnmkHome from '@/features/gnmk/home/index.vue';
import { isGnmkUser as checkGnmkUser } from '@/features/common/utils/gnmkRoles';
import JxxfHome from '@/features/jxxf/home/index.vue';

export default {
  components: { GnmkHome, JxxfHome },
  data () {
    return {
      isGnmkUser: false, // 是否为新业务系统专属角色用户
      isJxxfUser: false, // 是否为江西消防岗位分类用户
      todoEntryLoading: true, // 待办入口加载条件
      todoDataLoading: false, // 待办数据加载条件
      disableToolTip: false, // tooltip显示
      /* 顶部假期数据 Start */
      vacationParams: {
        wbxm: 0,
        wbjh: 0,
        jcxm: 0,
        pgxm: 0
      },
      vacationData: [
        {
          day: 0,
          text: '维保项目',
          imgSrc: './images/main/wb_icon.png',
          imgName: 'wbxm',
          path: '/xfwbgl/wbxm/index'
        },
        {
          day: 0,
          text: '维保计划',
          imgSrc: './images/main/wbjh_icon.png',
          imgName: 'wbjh',
          path: '/xfwbgl/wbjh/index'
        },
        {
          day: 0,
          text: '检测项目',
          imgSrc: './images/main/jc_icon.png',
          imgName: 'jcxm',
          path: '/xfjcgl/xmgl/index'
        },
        {
          day: 0,
          text: '评估项目',
          imgSrc: './images/main/pg_icon.png',
          imgName: 'pgxm',
          path: '/xfaqpg/pgxm/list'
        }
      ],
      /* 顶部假期数据 End */

      processList: [], // 维保任务进度列表
      /* 快捷入口数据 Start */
      manageEntrance: [
        {
          text: '维保项目',
          code: 'wb',
          imgSrc: './images/main/wb_icon.png',
          path: '/xfwbgl/wbxm/index'
        },
        {
          text: '维保计划',
          code: 'wbjh',
          imgSrc: './images/main/wbjh_icon.png',
          path: '/xfwbgl/wbjh/index'
        },
        {
          text: '检测项目',
          code: 'jc',
          imgSrc: './images/main/jc_icon.png',
          path: '/xfjcgl/xmgl/index'
        },
        {
          text: '评估项目',
          code: 'pg',
          imgSrc: './images/main/pg_icon.png',
          path: '/xfaqpg/pgxm/list'
        }
      ],
      /* 快捷入口数据 End */
      bgList: []
    };
  },
  methods: {
    /**
     * @description: 判断文字是否超出dom宽度,显示tooltip
     * @param {Object} e MouseEvent 鼠标事件对象
     * @return {*}
     */
    showToolTip (e) {
      const enableToolTip = this.checkTextRange(e.target);
      this.disableToolTip = !enableToolTip;
    },
    /**
     * @description: 判断文字是否超出dom宽度
     * @param {*}
     * @return {*}
     */
    checkTextRange (e) {
      const targetWidth = e.getBoundingClientRect().width;
      const range = document.createRange();
      range.setStart(e, 0);
      range.setEnd(e, e.childNodes.length);
      const rangeWidth = range.getBoundingClientRect().width;
      return rangeWidth > targetWidth;
    },
    /**
     * @description: 跳转到对应事项管理
     * @param {string} path 跳转页面路径
     * @return {*}
     */
    goToEntry (path) {
      this.openNavTab({
        path: path
      });
    },
    handleBgDetail (item) {
      // 消防评估
      if (item.bgdm === 'XFPG') {
        this.openNavTab({ name: 'pgxmDetail', params: { id: item.xmId } }, true);
      }
      // 消防检测
      if (item.bgdm === 'XFJC') {
        this.openNavTab({ name: 'viewXfjc', params: { xmId: item.xmId } }, true);
      }
      // 消防维保
      if (item.bgdm === 'XFWB') {
        this.openNavTab({ name: 'viewWbjh', params: { id: item.jhId } });
      }
    },
    queueTjInfo () {
      mainService.getXmNumber()
        .then(rsp => {
          this.vacationParams = rsp.data;
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    queryBg () {
      mainService.bgList()
        .then(rsp => {
          this.bgList = rsp.data;
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex > 3) {
        return 'is-success';
      } else if (rowIndex > 1) {
        return 'is-warning';
      }
      return '';
    },
    queryProcess () {
      mainService.getWbProcessList()
        .then(rsp => {
          this.processList = rsp.data;
        })
        .catch(err => {
          console.error('查询错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    init () {
      this.queryProcess();
      this.queueTjInfo();
    }
  },
  created () {
    const userInfo = this.$HMStoreService.getUserinfo() || {};
    this.isJxxfUser = userInfo.roleTypeDm === 'JXXF';
    // 江西消防优先于其他新业务角色，避免加载广东业务首页数据。
    this.isGnmkUser = !this.isJxxfUser && checkGnmkUser();
    if (!this.isGnmkUser && !this.isJxxfUser) {
      this.init();
    }
  },
  activated () {
    if (!this.isGnmkUser && !this.isJxxfUser) {
      this.init();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../main/main.scss";
</style>
